import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getConversations = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `conversations?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}